import styled from 'styled-components/macro';

import { distances } from '../../styles/constants';
import { Money, HumanPercentage } from '../../components/Formatters';
import { Small } from '../../components/Typography';
import Tooltip from '../../components/Tooltip';


import { PayoutSplit } from '../../types/checkout';
import { getSplitPaymentColor } from '../splitPaymentHelpers';


type SplitPaymentBarProps = {
    payoutSplits: PayoutSplit[];
    currency: string;
    missing?: number;
};

const SplitPaymentBar = ({ payoutSplits, currency, missing }: SplitPaymentBarProps) => {
    const total = payoutSplits.reduce((sum, p) => sum + p.amount, 0) + (missing || 0);
    return <Wrapper>
        {
            payoutSplits.filter(p => p.amount > 0).map((p, i) => {
                const percentage = (p.amount / total) * 100;
                return <Tooltip
                    key={`split-tooltip-${i}`}
                    title={
                        <>
                            <div><Money amount={p.amount} currency={currency} boldCurrency /> – <HumanPercentage value={percentage} /></div>
                            <TooltipSmall>{p.payout_destination_id}</TooltipSmall>
                        </>
                    }
                >
                    <StackedBar key={`split-${i}`} percentage={percentage} background={getSplitPaymentColor(i)} />
                </Tooltip>;
            })
        }
    </Wrapper>;
};

const Wrapper = styled.div`
    width: 100%;
    display:flex;
    justify-content: flex-start;
    align-items: stretch;
    height: ${distances.tiny};
    background: #f5f5f5;

`;

type StackedBarProps = {
    percentage: number;
    background: string;
}

const StackedBar = styled.div<StackedBarProps>`
    position: relative;
    background: ${props => props.background};
    width: ${props => props.percentage}%;
    min-width: ${distances.tiny};
    height: ${distances.tiny};
    display: flex;
    justify-content: center;
    transition: all 150ms ease-out;
`;

const TooltipSmall = styled(Small)`
     color: #fff;
     white-space: nowrap;
 `;




export default SplitPaymentBar;
